import { render, staticRenderFns } from "./ArticleSections.vue?vue&type=template&id=b9756e02&scoped=true&"
import script from "./ArticleSections.vue?vue&type=script&lang=js&"
export * from "./ArticleSections.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSections.vue?vue&type=style&index=0&id=b9756e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9756e02",
  null
  
)

export default component.exports